import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
  user;
  name = '';

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/components/app-header/app-header.component.ts